(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // 这里的 class 必须匹配你 theme.liquid 里的容器类名
      this.header = document.querySelector('.section-header') || this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;

      // 绑定滚动事件
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // 设置 CSS 变量以备使用
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // 情况 A: 滚动到最顶部（重置状态）
      if (scrollTop <= 100) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        this.currentScrollTop = scrollTop;
        return;
      }

      // 情况 B: 向下滚动 (隐藏 Header)
      if (scrollTop > this.currentScrollTop && scrollTop > 200) {
        if (!this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          this.header.classList.remove('animate');
        }
      } 
      // 情况 C: 向上滚动 (弹出 Header)
      else if (scrollTop < this.currentScrollTop) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
